import React from 'react';
import { Dropdown, DropdownProps, Form } from 'semantic-ui-react';

export interface DropdownFieldProps extends DropdownProps {
  label: string;
  required?: boolean;
}

const DropdownField = React.memo((props: DropdownFieldProps) => {
  return (
    <Form.Field style={props.style} required={props.required}>
      <label>{props.label}</label>
      <Dropdown search selection {...props} />
    </Form.Field>
  );
});

export default DropdownField;
